import { useAppSelector } from "~/app/store";
import { selectFetchStatusEndpointsInterval } from "~/features/andon/andon.slice";
import { useGetWorkstationsQuery } from "~/redux/warehouse/workstation.hooks";

export function useWorkstationPolling(): void {
  const pollingInterval = useAppSelector(selectFetchStatusEndpointsInterval);

  useGetWorkstationsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    skipPollingIfUnfocused: true,
    pollingInterval: pollingInterval > 0 ? pollingInterval : undefined
  });
}
